// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.8_webpack@5.99.7/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.8_webpack@5.99.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.5 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --spacing: 0.25rem;
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .dash-static {
    position: static;
  }
  .dash-container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .dash-mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .dash-bg-background {
    background-color: var(--background);
  }
  .dash-text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .dash-text-destructive {
    color: var(--destructive);
  }
  .dash-outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
}
:root {
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.205 0 0);
  --primary-foreground: oklch(0.985 0 0);
  --secondary: oklch(0.97 0 0);
  --secondary-foreground: oklch(0.205 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --destructive-foreground: oklch(0.577 0.245 27.325);
  --border: oklch(0.922 0 0);
  --input: oklch(0.922 0 0);
  --ring: oklch(0.708 0 0);
  --chart-1: oklch(0.646 0.222 41.116);
  --chart-2: oklch(0.6 0.118 184.704);
  --chart-3: oklch(0.398 0.07 227.392);
  --chart-4: oklch(0.828 0.189 84.429);
  --chart-5: oklch(0.769 0.188 70.08);
  --radius: 0.625rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);
}
.dash-dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.145 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.145 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: oklch(0.985 0 0);
  --primary-foreground: oklch(0.205 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.396 0.141 25.723);
  --destructive-foreground: oklch(0.637 0.237 25.331);
  --border: oklch(0.269 0 0);
  --input: oklch(0.269 0 0);
  --ring: oklch(0.439 0 0);
  --chart-1: oklch(0.488 0.243 264.376);
  --chart-2: oklch(0.696 0.17 162.48);
  --chart-3: oklch(0.769 0.188 70.08);
  --chart-4: oklch(0.627 0.265 303.9);
  --chart-5: oklch(0.645 0.246 16.439);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: oklch(0.488 0.243 264.376);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(0.269 0 0);
  --sidebar-ring: oklch(0.439 0 0);
}
@layer base {
  * {
    border-color: var(--border);
    outline-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  body {
    background-color: var(--background);
    color: var(--foreground);
  }
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-outline-style: solid;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,gEAEA;AAFA,iBAEA;AAFA,yCAEA;AAFA;EAAA;IAAA;6DAEA;IAFA;8BAEA;IAFA,kBAEA;IAFA,oBAEA;IAFA,2CAEA;IAFA,uCAEA;IAFA,4CAEA;EAAA;AAAA;AAFA;EAAA;IAAA,sBAEA;IAFA,SAEA;IAFA,UAEA;IAFA,eAEA;EAAA;EAFA;IAAA,gBAEA;IAFA,8BAEA;IAFA,WAEA;IAFA,2JAEA;IAFA,mEAEA;IAFA,uEAEA;IAFA,wCAEA;EAAA;EAFA;IAAA,SAEA;IAFA,cAEA;IAFA,qBAEA;EAAA;EAFA;IAAA,yCAEA;IAFA,iCAEA;EAAA;EAFA;IAAA,kBAEA;IAFA,oBAEA;EAAA;EAFA;IAAA,cAEA;IAFA,gCAEA;IAFA,wBAEA;EAAA;EAFA;IAAA,mBAEA;EAAA;EAFA;IAAA,gJAEA;IAFA,wEAEA;IAFA,4EAEA;IAFA,cAEA;EAAA;EAFA;IAAA,cAEA;EAAA;EAFA;IAAA,cAEA;IAFA,cAEA;IAFA,kBAEA;IAFA,wBAEA;EAAA;EAFA;IAAA,eAEA;EAAA;EAFA;IAAA,WAEA;EAAA;EAFA;IAAA,cAEA;IAFA,qBAEA;IAFA,yBAEA;EAAA;EAFA;IAAA,aAEA;EAAA;EAFA;IAAA,wBAEA;EAAA;EAFA;IAAA,kBAEA;EAAA;EAFA;IAAA,gBAEA;EAAA;EAFA;IAAA,cAEA;IAFA,sBAEA;EAAA;EAFA;IAAA,eAEA;IAFA,YAEA;EAAA;EAFA;IAAA,aAEA;IAFA,8BAEA;IAFA,gCAEA;IAFA,uBAEA;IAFA,cAEA;IAFA,gBAEA;IAFA,6BAEA;IAFA,UAEA;EAAA;EAFA;IAAA,mBAEA;EAAA;EAFA;IAAA,0BAEA;EAAA;EAFA;IAAA,sBAEA;EAAA;EAFA;IAAA,UAEA;EAAA;EAFA;IAAA;MAAA,mBAEA;MAFA;QAAA,yDAEA;MAAA;IAAA;EAAA;EAFA;IAAA,gBAEA;EAAA;EAFA;IAAA,wBAEA;EAAA;EAFA;IAAA,eAEA;IAFA,mBAEA;EAAA;EAFA;IAAA,oBAEA;EAAA;EAFA;IAAA,UAEA;EAAA;EAFA;IAAA,gBAEA;EAAA;EAFA;IAAA,gBAEA;EAAA;EAFA;IAAA,kBAEA;EAAA;EAFA;IAAA,YAEA;EAAA;EAFA;IAAA,wBAEA;EAAA;AAAA;AAFA;EAAA;IAAA,gBAEA;EAAA;EAFA;IAAA,WAEA;IAFA;MAAA,gBAEA;IAAA;IAFA;MAAA,gBAEA;IAAA;IAFA;MAAA,gBAEA;IAAA;IAFA;MAAA,gBAEA;IAAA;IAFA;MAAA,gBAEA;IAAA;EAAA;EAFA;IAAA,uCAEA;EAAA;EAFA;IAAA,mCAEA;EAAA;EAFA;IAAA,0BAEA;IAFA,4DAEA;EAAA;EAFA;IAAA,yBAEA;EAAA;EAFA;IAAA,sCAEA;IAFA,kBAEA;EAAA;AAAA;AAFA;EAAA,0BAEA;EAFA,8BAEA;EAFA,oBAEA;EAFA,mCAEA;EAFA,uBAEA;EAFA,sCAEA;EAFA,2BAEA;EAFA,sCAEA;EAFA,4BAEA;EAFA,wCAEA;EAFA,wBAEA;EAFA,oCAEA;EAFA,yBAEA;EAFA,qCAEA;EAFA,wCAEA;EAFA,mDAEA;EAFA,0BAEA;EAFA,yBAEA;EAFA,wBAEA;EAFA,oCAEA;EAFA,mCAEA;EAFA,oCAEA;EAFA,oCAEA;EAFA,mCAEA;EAFA,kBAEA;EAFA,2BAEA;EAFA,sCAEA;EAFA,mCAEA;EAFA,8CAEA;EAFA,iCAEA;EAFA,6CAEA;EAFA,kCAEA;EAFA,gCAEA;AAAA;AAFA;EAAA,8BAEA;EAFA,8BAEA;EAFA,wBAEA;EAFA,mCAEA;EAFA,2BAEA;EAFA,sCAEA;EAFA,2BAEA;EAFA,sCAEA;EAFA,6BAEA;EAFA,wCAEA;EAFA,yBAEA;EAFA,oCAEA;EAFA,0BAEA;EAFA,qCAEA;EAFA,wCAEA;EAFA,mDAEA;EAFA,0BAEA;EAFA,yBAEA;EAFA,wBAEA;EAFA,qCAEA;EAFA,mCAEA;EAFA,mCAEA;EAFA,mCAEA;EAFA,oCAEA;EAFA,2BAEA;EAFA,sCAEA;EAFA,6CAEA;EAFA,8CAEA;EAFA,kCAEA;EAFA,6CAEA;EAFA,kCAEA;EAFA,gCAEA;AAAA;AAFA;EAAA;IAAA,2BAEA;IAFA,0BAEA;IAFA;MAAA,gEAEA;IAAA;EAAA;EAFA;IAAA,mCAEA;IAFA,wBAEA;EAAA;AAAA;AAFA;EAAA,WAEA;EAFA,eAEA;EAFA,oBAEA;AAAA;AAFA;EAAA;IAAA;MAAA,yBAEA;IAAA;EAAA;AAAA","sourcesContent":["@import \"tailwindcss\";\n@import \"pfm-core/dist/theme.css\";\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
